__turbopack_context__.v({
  "resourceFooter": "resource-footer-module-scss-module__LiHfIG__resourceFooter",
  "resourceFooterContent": "resource-footer-module-scss-module__LiHfIG__resourceFooterContent",
  "resourceFooterTitle": "resource-footer-module-scss-module__LiHfIG__resourceFooterTitle",
});
